import React from 'react';
import { useNavigate } from 'react-router-dom';

const AboutUs = () => {
  const navigate = useNavigate();

  const handleNavigateToHome = () => {
    navigate('/dashboard'); // Adjust the route as per your app
  };

  return (
    <div className="about-container">
      <h1 className="about-title animate-fadeIn">Welcome to ButterFly Wings Pvt Ltd</h1>
      <p className="about-description animate-slideUp">
        At ButterFly Wings Pvt Ltd, we are committed to transforming your business ideas into reality. 
        We specialize in developing top-notch software solutions such as mobile applications, point-of-sale (POS) systems, 
        websites, streaming apps, and chatting apps. With a dedicated team of experts, we provide innovative solutions that 
        cater to your needs and enhance user experiences.
      </p>

      <div className="about-services animate-scaleUp">
        <h2>Our Services</h2>
        <ul>
          <li>Mobile Application Development</li>
          <li>POS Systems</li>
          <li>Website Development</li>
          <li>Streaming Apps</li>
          <li>Chatting Apps</li>
        </ul>
      </div>

      <div className="about-mission animate-fadeIn">
        <h2>Our Mission</h2>
        <p>
          Our mission is to provide cutting-edge software solutions that empower businesses to reach new heights. 
          We believe in the power of technology to drive success and innovation, and we are dedicated to delivering 
          solutions that make a difference.
        </p>
      </div>

      <button className="home-button" onClick={handleNavigateToHome}>
        Back to Home
      </button>

      <style jsx>{`
        .about-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          min-height: 100vh;
          padding: 20px;
          background-color: black;
          color: #00FFFF;
          text-align: center;
        }

        .about-title {
          font-size: 3rem;
          margin-bottom: 20px;
          color: #00FFFF;
          font-family: 'Arial', sans-serif;
        }

        .about-description, .about-services, .about-mission {
          font-size: 1.5rem;
          margin: 20px 0;
          color: #E0FFFF;
          max-width: 800px;
        }

        ul {
          list-style-type: none;
          padding: 0;
        }

        ul li {
          font-size: 1.2rem;
          color: #B0E0E6;
          margin: 10px 0;
        }

        .home-button {
          padding: 10px 20px;
          background-color: #00FFFF;
          color: black;
          border: none;
          border-radius: 5px;
          cursor: pointer;
          font-size: 1.2rem;
          transition: transform 0.3s ease, background-color 0.3s ease;
        }

        .home-button:hover {
          transform: scale(1.1);
          background-color: #009ACD;
        }

        /* Animations */
        .animate-fadeIn {
          opacity: 0;
          animation: fadeIn 2s forwards;
        }

        @keyframes fadeIn {
          to {
            opacity: 1;
          }
        }

        .animate-slideUp {
          transform: translateY(20px);
          opacity: 0;
          animation: slideUp 2s forwards;
        }

        @keyframes slideUp {
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }

        .animate-scaleUp {
          transform: scale(0.9);
          opacity: 0;
          animation: scaleUp 2s forwards;
        }

        @keyframes scaleUp {
          to {
            transform: scale(1);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default AboutUs;
